import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Banner,
  Box,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

import messages from './messages';

const AssignmentRestrictionBanner = ({ restriction }) => {
  if (!restriction) {
    return null;
  }

  const { floorPlanName } = restriction;

  return (
    <Box sx={{ mt: 1, mb: 2 }}>
      <Banner
        status="info"
        message={
          floorPlanName ? (
            <FormattedMessage
              {...messages.assignmentRestrictionBanner}
              values={{ floorPlanName }}
            />
          ) : (
            <FormattedMessage
              {...messages.assignmentRestrictionBannerNoFloorPlan}
            />
          )
        }
      />
    </Box>
  );
};

export default AssignmentRestrictionBanner;
